export const listHabiLeadsStacks = async (token: string, page = "1", limit = "10") => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    const result = await fetch(`${process.env.REACT_APP_MICRO_GLOBAL_ENTITY}qualify_ondemand_properties?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
    return result.json();
}
export const createHabiStackLeads = async (token: string, count: number) => {
    const result = await fetch(`${process.env.REACT_APP_MICRO_GLOBAL_ENTITY}qualify_ondemand_properties`, {
        method: 'POST',
        body: JSON.stringify({ count: count.toString() }),
        headers: { Authorization: `Bearer ${token}` }
    });
    return result.json();
}